import {
  formatDecimal,
  formatMilhoes,
  formatMilhoesInteiro,
  formatPercentual,
  formatQuantidade,
} from "../../home.format";
import type { OverviewViewModel, OverviewViewProps } from "./types-overview-view";

/** Formata a Visão Geral para o protótipo (`989,3 M`, `48%`); a View só desenha os textos prontos. */
export function useOverviewView({ overview }: OverviewViewProps): OverviewViewModel {
  const { capex, outlook, tipoObra, escopo, custosPorSubsistema } = overview;

  return {
    capex: {
      titulo: `Capex dos ${formatQuantidade(capex.anos)} Anos`,
      total: formatMilhoes(capex.total),
      ariaLabel: `Capex por ano, em milhões de reais. Total de ${formatMilhoes(capex.total)}.`,
      serie: capex.serie,
      formatValue: formatMilhoes,
      formatPointLabel: formatDecimal,
    },
    outlook: {
      titulo: `Outlook de Capex de Obras - ${outlook.ano}`,
      valor: formatMilhoes(outlook.valor),
      variacao: outlook.variacaoOrcamentoPercentual,
      totalObras: formatQuantidade(outlook.totalObras),
      obrasExecutadas: formatQuantidade(outlook.obrasExecutadas),
    },
    tipoObra: {
      titulo: `Total por Tipo de obra - ${tipoObra.ano}`,
      itens: tipoObra.itens.map((item) => ({
        sigla: item.sigla,
        testId: `home-tipo-obra-${item.sigla}`,
        valor: formatMilhoes(item.valor),
        percentual: formatPercentual(item.percentual),
      })),
    },
    escopo: escopo.map((bloco) => ({
      id: bloco.id,
      testId: `home-card-${bloco.id}`,
      variacaoTestId: `home-escopo-${bloco.id}-variacao`,
      label: bloco.label,
      percentual: formatPercentual(bloco.percentual),
      valor: formatMilhoes(bloco.valor),
      variacao: bloco.variacaoPercentual,
    })),
    custosPorSubsistema: {
      ano: String(custosPorSubsistema.ano),
      itens: custosPorSubsistema.itens.map((item) => ({
        codigo: item.codigo,
        nome: item.nome,
        valor: formatMilhoesInteiro(item.valor),
      })),
    },
  };
}
